<template>
  <div class="flex-1">
    <div>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>
